import React from "react";
import InlineEdit from "@atlaskit/inline-edit";
import {ConfluenceLinkAutocomplete} from "./ConfluenceLinkAutocomplete";
import classNames from "classnames";
import {MenuItem} from "navigation-common/types/navigation-types";

interface LinkComponentProps {
    menuItem: MenuItem,
    linkChangeTrigger: (value: string) => void,
    setIsAutocompleteOpen: (state: boolean) => void,
}

export default function LinkInputField(props: LinkComponentProps) {

    return <InlineEdit
        defaultValue={props.menuItem.link}
        editView={({errorMessage, ...fieldProps}) => (
            <ConfluenceLinkAutocomplete{...fieldProps} setIsAutocompleteOpen={props.setIsAutocompleteOpen}/>
        )}
        readView={() => (
            <div className={classNames({"empty": !props.menuItem.link})} data-testid="read-view">
                {props.menuItem.link || 'Enter link'}
            </div>
        )}
        onConfirm={(value) => props.linkChangeTrigger(value)}
        hideActionButtons
    />
}
